import React from 'react';
import AppFooter from '../../../../components/AppFooter';

/*
 This component is used for the Quest header if "showHeader" is set to true
*/
export default () => <AppFooter />;
